export default __webpack_public_path__ + "static/media/post1.7a94fa87.jpg";